import React, { useState } from 'react'
import { firestore } from '../../../firebase'

function AddHostcup() {

    const [title, setTitle] = useState("")
    const [year, setYear] = useState(2020)
    const [error, setError] = useState("")
    const [message, setMessage] = useState("")

    function submitHandler(e) {
        e.preventDefault()
        try {
            const hostcupRef = firestore.collection("hostcup");
            const data = {
                title,
                year
            }
            hostcupRef.add(data)
            setMessage("Lagt til")
        } catch (error) {
            console.log(error)
            setError("Kunne ikke legge til")
        }
    }

    return (
        <form onSubmit={submitHandler}>
            <label>Tittel</label>
            <input className="form-control mb-2" value={title} onChange={e => setTitle(e.target.value)} placeholder="Tittel" />
            <label>År / Sesong</label>
            <input type="number" className="form-control mb-3" value={year} onChange={e => setYear(e.target.value)} placeholder="År" />
            
            {message && <div className="alert alert-success">{message}</div>}
            {error && <div className="alert alert-danger">{error}</div>}
            <button className="btn btn-block btn-success ">Legg til høstcup</button>
        </form>
    )

}
export default AddHostcup